import { createAction } from "@reduxjs/toolkit";
import type {
  SignAllAttendanceSheetsBody,
  SignAllAttendanceSheetsResponse,
} from "@shared-kernel/application/ports/student/student-repository";
import { createApiThunk } from "@shared-kernel/application/create-api-thunk";

export const signAllStudentAttendanceSheets = createApiThunk<SignAllAttendanceSheetsResponse, SignAllAttendanceSheetsBody>(
  "student/signAllAttendanceSheets",
  async (payload: SignAllAttendanceSheetsBody, { extra: { studentRepository } }) => {
    return studentRepository!.signAllAttendanceSheets(payload);
  },
);

export const resetSignAllStudentAttendanceSheetsState = createAction("student/resetSignAllAttendanceSheetsState");
